import styled from "styled-components";

export const Container = styled.div`
    padding: 24px;
    background: ${({ theme }) => theme.pink50};
    border: 1px solid ${({ theme }) => theme.gray100};
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export const Title = styled.h1`
    color: ${({ theme }) => theme.gray800};
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0.024px;
`;

export const Wrapper = styled.div<{ fullWidth?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: ${({ fullWidth }) => (fullWidth ? "auto" : "242px")};
`;

export const Buttons = styled.div`
    display: flex;
    gap: 20px;
    max-width: 242px;
`;

export const InputFile = styled.input`
    opacity: 0;
    position: absolute;
    height: 48px;
    width: 242px;
    margin-left: -20px;
    cursor: pointer;
    border-radius: 4px;
`;

export const FileName = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme.gray800};
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0.024px;
    margin-top: -20px;
    display: flex;
    align-items: center;

    span {
        color: ${({ theme }) => theme.gray500};
    }

    svg {
        cursor: pointer;
    }
`;
